module.exports = __webpack_public_path__ + "static/media/overview_db.955c4f53.webp";